import { EVENTS_OPEN_ACTION_ENABLE_MODAL } from './constants';

export function openActionEnableModal(args) {
  return {
    type: EVENTS_OPEN_ACTION_ENABLE_MODAL,
    data: args,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_OPEN_ACTION_ENABLE_MODAL:
      return {
        ...state,
        isOpenActionPropModal: false,
        isOpenActionEnableModal: true,
        selectedAction: action.data,
      };

    default:
      return state;
  }
}
